import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '@/composables/useAuth'
import { useTemplateApp } from '@/composables/useTemplateApp'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    eventValue: null
  },
  emits: ["ios-send", "android-send"],
  setup(__props: any) {





const { isAuthenticated } = useAuth()
const { open: openTemplateApp } = useTemplateApp()

/** 移設元の getMode 相当。ビルド時定数なので computed にしない */
const appMode = process.env.VUE_APP_MODE

return { __sfc: true,isAuthenticated, openTemplateApp, appMode }
}

})